import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="pt-16">
      {/* Header Section */}
      <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h1 className="text-5xl font-extrabold mb-4">Privacy Policy</h1>
          <p className="text-blue-100 text-lg">Last updated: January 30, 2025</p>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-10 py-16">
        <div className="prose prose-lg max-w-none leading-relaxed">
          <p className="text-gray-700 text-lg">
            At <strong>UCX</strong>, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8">Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to enhance your browsing experience and analyze website traffic. This includes:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Google Analytics:</strong> To understand how visitors interact with our website and improve our services.</li>
            <li><strong>Google Tag Manager:</strong> To manage and deploy marketing and analytics tags.</li>
            <li><strong>Essential Cookies:</strong> Required for basic website functionality and security.</li>
          </ul>
          <p>
            You can control cookie settings through your browser preferences. However, disabling certain cookies may impact website functionality.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8">Information We Collect</h2>
          <p>We collect various types of information, including:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Personal Information:</strong> Name, email address, phone number.</li>
            <li><strong>Company Information:</strong> Business name, industry, and role.</li>
            <li><strong>Account Credentials:</strong> Username, password (encrypted), and authentication details.</li>
            <li><strong>Payment Information:</strong> Billing details, transaction history, and payment method.</li>
            <li><strong>Communication Preferences:</strong> Marketing opt-ins and notification settings.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">How We Use Your Information</h2>
          <p>
            We use the collected information for the following purposes:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>To provide, operate, and improve our services.</li>
            <li>To process transactions and send related information.</li>
            <li>To send administrative and support communications.</li>
            <li>To personalize user experience and content recommendations.</li>
            <li>To enforce our terms, conditions, and policies.</li>
            <li>To ensure compliance with applicable legal obligations.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">Information Sharing</h2>
          <p>
            We do not sell or rent your personal data. However, we may share your information with:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Service Providers:</strong> Third-party companies that assist in delivering our services.</li>
            <li><strong>Professional Advisors:</strong> Legal, financial, and consulting professionals.</li>
            <li><strong>Regulatory Authorities:</strong> Government bodies when required by law or in response to legal processes.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">Security Measures</h2>
          <p>
            We implement advanced security protocols to protect your data, including:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Encryption of sensitive information.</li>
            <li>Regular security audits and penetration testing.</li>
            <li>Access controls and authentication measures.</li>
            <li>Secure data storage and retention policies.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">Your Rights and Choices</h2>
          <p>
            Depending on your location, you may have the following rights:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Access:</strong> Request a copy of your personal data.</li>
            <li><strong>Correction:</strong> Update inaccurate or incomplete information.</li>
            <li><strong>Deletion:</strong> Request the removal of your personal data.</li>
            <li><strong>Objection:</strong> Restrict the processing of your data.</li>
            <li><strong>Data Portability:</strong> Obtain your data in a structured format.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">Policy Updates</h2>
          <p>
            We may update this Privacy Policy periodically. Changes will be posted on this page with a revised date.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Contact Us</h2>
          <p>
            If you have any questions or concerns, please contact us:
          </p>
          <ul className="list-none space-y-2">
            <li><strong>Email:</strong> <a href="mailto:privacy@ucx.co" className="text-blue-600 hover:underline">privacy@ucx.co</a></li>
            <li><strong>Phone:</strong> <a href="tel:+18442193935" className="text-blue-600 hover:underline">844-219-3935</a></li>
            <li><strong>Address:</strong> 1348 Hwy 287, Suite 300, Waxahachie, TX 75165</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
